import {
  ClientGroupPendingJoinAcceptConfirmationGroupMembershipStatusEnum,
  ClientGroupPendingJoinDenyConfirmationGroupMembershipStatusEnum
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { State, StateView } from 'components';
import { useAcceptInvitation, useDenyInvitation } from 'hooks';
import { FC, useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { isEmptyOrNull } from 'utils';

const errorMessages = ['Ups, etwas ist schiefgelaufen!'];

export const GroupJoin: FC = () => {
  const [searchParams] = useSearchParams();

  const personId = searchParams.get('person') ?? undefined;
  const mailToken = searchParams.get('token') ?? undefined;
  const type = searchParams.get('type') ?? undefined;
  const groupId = searchParams.get('group') ?? undefined;
  const groupAdminId = searchParams.get('admin') ?? undefined;

  const { mutate: acceptInvitation } = useAcceptInvitation();
  const { mutate: denyInvitation } = useDenyInvitation();

  const [state, setState] = useState<State>(State.Loading);
  const [messages, setMessages] = useState<string[]>();

  const handleAcceptDenyInvitation = useCallback(() => {
    if (mailToken && personId && type && groupId && groupAdminId) {
      if (type === 'accept') {
        acceptInvitation(
          {
            mailToken,
            acceptingPersonId: groupAdminId,
            clientGroupPendingJoinAcceptRequest: {
              groupId,
              personIdToAccept: personId
            }
          },
          {
            onError: () => {
              setState(State.Error);
              setMessages(errorMessages);
            },
            onSuccess: (response) => {
              if (response.groupMembershipStatusChanged) {
                setState(State.Success);
                setMessages(['Gruppenmitgliedschaft bestätigt!']);
              } else {
                // group membership was already accepted or denied previously
                setState(State.Warning);
                setMessages(
                  response.groupMembershipStatus ===
                    ClientGroupPendingJoinAcceptConfirmationGroupMembershipStatusEnum.Approved
                    ? ['Die Gruppenmitgliedschaft wurde bereits bestätigt!']
                    : ['Die Gruppenmitgliedschaft wurde bereits abgelehnt!']
                );
              }
            }
          }
        );
      }
      if (type === 'deny') {
        denyInvitation(
          {
            mailToken,
            denyingPersonId: groupAdminId,
            clientGroupPendingJoinDenyRequest: {
              groupId,
              personIdToDeny: personId
            }
          },
          {
            onError: () => {
              setState(State.Error);
              setMessages(errorMessages);
            },
            onSuccess: (response) => {
              if (response.groupMembershipStatusChanged) {
                setState(State.Success);
                setMessages(['Gruppenmitgliedschaft abgelehnt!']);
              } else {
                // group membership was already accepted or denied previously
                setState(State.Warning);
                setMessages(
                  response.groupMembershipStatus ===
                    ClientGroupPendingJoinDenyConfirmationGroupMembershipStatusEnum.Approved
                    ? ['Die Gruppenmitgliedschaft wurde bereits bestätigt!']
                    : ['Die Gruppenmitgliedschaft wurde bereits abgelehnt!']
                );
              }
            }
          }
        );
      }
    }
  }, [
    mailToken,
    personId,
    type,
    groupId,
    groupAdminId,
    acceptInvitation,
    denyInvitation
  ]);

  useEffect(() => {
    if (
      !isEmptyOrNull(personId) &&
      !isEmptyOrNull(mailToken) &&
      !isEmptyOrNull(type) &&
      (type === 'accept' || type === 'deny') &&
      !isEmptyOrNull(groupId) &&
      !isEmptyOrNull(groupAdminId)
    ) {
      handleAcceptDenyInvitation();
    } else {
      setState(State.Error);
      setMessages(errorMessages.concat(['MISSING_OR_INVALID_QUERY_PARAM']));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personId, groupAdminId, groupId, mailToken, type]);

  return <StateView state={state} messages={messages} />;
};
